import { CustomAxios, getResponseData } from 'redux/axios';
import {
  Org,
  OrgHierarchy,
  SearchOrgsRequest_SearchEntity,
  SearchOrgsResponse,
} from '@weave/schema-gen-ts/dist/apis/api/identity/v1/api.pb';
import { REACT_APP_API_SCHEMAS_URL } from '../../config/app';

const IDENTITY_BASE_URL = REACT_APP_API_SCHEMAS_URL;

// searchOrgsAndLocations calls the IAM SearchOrgs endpoint (backed by
// iam/internal/grpc/org.go#SearchOrgs), scoping the results to a single
// entity type via searchEntity so callers only get back the results they need.
const searchOrgsAndLocations = async (
  query: string,
  searchEntity: SearchOrgsRequest_SearchEntity
): Promise<SearchOrgsResponse> => {
  const response = await CustomAxios.get(`/identity/v1/orgs:search`, {
    baseURL: IDENTITY_BASE_URL,
    params: { query, searchEntity },
  });
  return getResponseData(response);
};

export const searchOrgs = async (query: string) => {
  const { orgs } = await searchOrgsAndLocations(
    query,
    SearchOrgsRequest_SearchEntity.ORG
  );
  return orgs ?? [];
};

export const getOrg = async (orgId: string): Promise<Org> => {
  const response = await CustomAxios.get(`/identity/v1/orgs/${orgId}`, {
    baseURL: IDENTITY_BASE_URL,
  });
  return getResponseData<Org>(response);
};

// getOrgHierarchy fetches an org along with its divisions and each division's
// locations via iam/internal/grpc/org.go#GetOrgHierarchy, so the org details page
// can display the full hierarchy and let a user drill down into a location.
export const getOrgHierarchy = async (orgId: string): Promise<OrgHierarchy> => {
  const response = await CustomAxios.get(`/identity/v1/orgs/${orgId}/hierarchy`, {
    baseURL: IDENTITY_BASE_URL,
  });
  return getResponseData<OrgHierarchy>(response);
};
